module.exports = __webpack_public_path__ + "img/IMG_2368_L_BlackMatted_MockedUp.c3157d73.jpg";